import { Controller } from '@hotwired/stimulus';
import { application } from 'src';

application.register(
  'line-schedule-requests-form-time-shift-type-toggle',
  class extends Controller {
    static targets = ['timeShiftType'];

    OPTIONS = {
      ingoing: { text: 'Cheguem às', value: 'schedule_arrival' },
      outgoing: { text: 'Saiam às', value: 'schedule_departure' }
    };

    toggle (event) {
      const selectedDirection = event.target.value;
      const unselectedDirection = this.#unselectedDirection(selectedDirection);
      const selectedOptionData = this.OPTIONS[selectedDirection];
      const unselectedOptionValue = this.OPTIONS[unselectedDirection].value;
      const timeShiftTypeSelect = this.timeShiftTypeTarget;
      const fixedTimeOption = Array.from(timeShiftTypeSelect.options).find(option => option.value === unselectedOptionValue);

      if(!fixedTimeOption) return;

      fixedTimeOption.value = selectedOptionData.value;
      fixedTimeOption.innerText = selectedOptionData.text;
    }

    #unselectedDirection (selectedDirection) {
      if (selectedDirection === 'ingoing') return 'outgoing';
      if (selectedDirection === 'outgoing') return 'ingoing';
    }
  }
);
